import React, { useState, useEffect } from "react";
import Header from '../layout/header'
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import { useSelector } from "react-redux";
import { apiCallingPost } from "../api/services"
import noData from "../assets/images/no-data.png"
import Loader from "../assets/images/loader.gif"
import BannerImg from "../assets/images/admin-banner.webp"
import { FiSearch } from "react-icons/fi";
import { RiDeleteBinLine } from "react-icons/ri";
import { MdOutlineEdit } from "react-icons/md";
import { ToastContainer, toast } from 'react-toastify';
import Pagination from "react-js-pagination";
import AddUser from './user-add';

function UserList() {
  const { userData } = useSelector((state) => state.masterData)
  const { isAuthenticated } = useSelector((state) => state.authentication);
  const navigate = useNavigate();
  const [offset, setOffset] = useState(0)
  const [itemsCountPerPage, setItemsCountPerPage] = useState(10)
  const [userList, setUserList] = useState([])
  const [userTotalCount, setUserTotalCount] = useState("")
  const [userName, setUserName] = useState("")
  const [loading, setLoading] = useState(false)
  const [fullAccessFlag, setFullAccessFlag] = useState(false)
  const [activePage, setActivePage] = useState(1)
  const [mode, setMode] = useState("")
  const [selectedUser, setSelectedUser] = useState([])
  const [addUserFlag, SetAddUserFlag] = useState(false)
  const [isDelete, setIsDelete] = useState(false)
  const [selectedToDelete, setSelectedToDelete] = useState(null);

  useEffect(() => {
    userListFn(userName, offset);
    if (!isAuthenticated) {
      window.location.href = "/login"
    }

    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        cancelPopup();
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [])

  const userListFn = async (userName, offsetNo) => {
    setLoading(true)
    let postData = {
      userId: "",
      userName: userName,
      offset: offsetNo,
      max: itemsCountPerPage,
      roleId: "3"
    }
    try {
      const response = await apiCallingPost("api/user/userList", postData);
      // console.log("........response.......",response);
      
      const { data } = response;
      if (data.success === "1") {
        setUserList(data.result)
        setFullAccessFlag(data.hasFullAccess)
        setUserTotalCount(Number(data.totalCount))
      }
      else {
        setUserList([])
        setUserTotalCount(0)
      }
    } catch (error) {
      console.error("Error fetching user list:", error);
      setUserList([]);
      setUserTotalCount(0)
    } finally {
      setLoading(false);
    }

  }

  const grantAccess = async (event, list) => {
    setFullAccessFlag(event.target.checked)
    let postData = {
      userIds: [list.user_id],
      modifiedOn: Date.now(),
      modifiedBy: userData.userId,
      hasFullAccess: event.target.checked
    }
    try {
      const response = await apiCallingPost("api/user/grantAccessToUsers", postData);
      const { data } = response;
      if (data.success === "1") {
        setFullAccessFlag(event.target.checked)
        userListFn(userName, offset);
        if (event.target.checked === true) {
          toast.success(`Full access disabled to the user: ${list.display_name}.`);
        }
        else {
          toast.success(`Full access has been granted to the user: ${list.display_name}`);
        }
      }
      else {
        toast.error("Unable to modify the full access option.");
      }
    } catch (error) {
      toast.error("Error fetching user list:", error);
    }
  }

  const handlePageChange = (pageNumber) => {
    setLoading(true);
    let offsetNo = (pageNumber - 1) * itemsCountPerPage;
    setOffset(offsetNo);
    setActivePage(pageNumber);
    userListFn(userName, offsetNo);
  }

  const addUserFn = (mode, data) => {
    setSelectedUser(data)
    setMode(mode)
    SetAddUserFlag(true)
  }

  const deleteUser = async (data) => {
    // if (window.confirm("Do you want to delete?")) {
    if (!selectedToDelete) return;
    const milliseconds = new Date().getTime();
    let postData = {
      updated_on: milliseconds,
      id: selectedToDelete.user_id
    }
    try {
      const { data } = await apiCallingPost("api/authentication/userDelete", postData);
      if (data.success === "1") {
        toast.success(`User deleted successfully.`);
        let postData = {
          "uid": selectedToDelete.idp_user_id
        }
        const { dataresponse } = await apiCallingPost("api/authentication/delete_idp_user", postData);

        let offsetCount = 0
        if ((userTotalCount - 1) > ((activePage - 1) * itemsCountPerPage)) {
          offsetCount = offset
        }
        else {
          setActivePage(activePage - 1)
          offsetCount = offset - itemsCountPerPage
        }
        setOffset(offsetCount)
        setTimeout(() => {
          userListFn(userName, offsetCount);
        }, 1000);
      }
      else {
        toast.error(`Something went wrong.`);
      }

    } catch (error) {
      console.error("Error Delete User:", error);
    }
    cancelpopup();
    // }
  }
  const cancelPopup = () => {
    SetAddUserFlag(false)
    document.body.style.overflow = 'auto';
  }
  const cancelpopup = () => {
    setIsDelete(false)
    setSelectedToDelete(null);
  }
  return (
    <div className='home-wrapper main-wrapper  main-wrapper-cms'>
      <ToastContainer />
      <Header />
      <div className=' banner-admin'>
        <div className='banner-admin-div'>
          <img className='img-fluid banner-admin-img' src={BannerImg} alt='Banner image' width={"100%"} height={500} />
        </div>
        <div className='search-wrapper'>
          <div className='container'>
            <div className='search-sub-wrap'>
              <div className="row w-100 justify-content-end">
                <div className='col-12 col-md-2 banner-title-admin'>
                  User List
                </div>
                <div className='col-12 col-md-7 col-lg-5 search-section'>
                  <div className='search-div'>
                    <FiSearch className='search-input-icon' />
                    <input type='text' className='search-input mb-0' placeholder='Name / Email / Mobile Search'
                      onChange={(e) => {
                        setUserName(e.target.value)
                        if (e.target.value === "") {
                          setOffset(0)
                          setActivePage(1)
                          userListFn(e.target.value, 0)
                        }
                        else if (e.target.value.length >= 3) {
                          setOffset(0)
                          setActivePage(1)
                          userListFn(e.target.value, 0)
                        }
                      }} />
                  </div>

                </div>
              </div>

            </div>
          </div>
        </div>

      </div>
      <div className="container mt-4 mt-md-5">
        <div className="col-md-12 text-end">
          <button onClick={() => addUserFn("Add", "")} className="accept-all-btn">Add User</button>
        </div>
        {isDelete &&
          <div className="modal-admin-wrapper multiple-upload" >
            <div className="modal-ad-popup modal-md">
              <div className="modal-innerpopup ">
                <div className="modal-headdiv d-flex justify-content-between">
                  <h5 className="modal-head w-100 text-center">Do you want to delete?</h5>
                  {/* <span className="closeBtn"><IoCloseOutline size={32} onClick={() => cancelpopup()} /></span> */}
                </div>
              </div>
              <div className="tag-popup-footer">
                <div className="d-flex align-items-center gap-2">
                  <button
                    type="button"
                    className="accept-all-btn w-100 py-2 accept-all-gray"
                    onClick={() => cancelpopup()}
                  >
                    Cancel
                  </button>

                  <button
                    type="button"
                    className="accept-all-btn w-100 py-2 d-flex align-items-center gap-2 justify-content-center"
                    onClick={() => deleteUser()}
                  >
                    Ok
                  </button>
                </div>
              </div>
            </div>
          </div>}
        <div className='table-responsive'>

          {!loading ? (
            userTotalCount > 0 ? (
              <>
                <table className="table table-bordered admin-list-table">
                  <thead>
                    <tr>
                      <th className='text-center'>#</th>
                      <th className=''>User Details</th>
                      <th className='text-center' style={{ whiteSpace: 'nowrap' }}>Full Access</th>
                      <th className='text-center'>Date</th>
                      {userData?.roleDisplayName === `Super_admin` &&
                        <th className='text-center'>Action</th>
                      }
                    </tr>
                  </thead>
                  <tbody>
                    {userList.map((data, i) => (
                      <tr key={data.id}>
                        <td className='text-center'>{(offset * 1) + i + 1}</td>
                        <td>
                          <div className='table-sides'>
                            <div>
                              <div>{data.display_name} </div>
                              <div className='sub-text'>{data.email_id}</div>
                              <div className='sub-text'>{data.mobile_number}</div>
                            </div>
                          </div>
                        </td>
                        <td className='text-center'>
                          <div className="checkbox-wrapper-1">
                            <input id={`example${i}`} className="substituted" type="checkbox" aria-hidden="true"
                              checked={data.hasFullAccess}
                              onChange={(e) => grantAccess(e, data)}
                            />
                            <label htmlFor={`example${i}`}></label>
                          </div>
                        </td>
                        <td style={{ whiteSpace: 'nowrap' }} className='text-center'>{moment(Number(data.created_on)).format('DD-MM-YYYY')}</td>
                        {userData?.roleDisplayName === `Super_admin` &&
                          <td className='text-center'>
                            <MdOutlineEdit className='theme-color cursor-pointer mt-2' size={20}
                              onClick={() => addUserFn("Edit", data)} />

                            <RiDeleteBinLine className='text-danger cursor-pointer mt-2 ms-3' size={17}
                              // onClick={() => deleteUser(data)}
                              onClick={() => {
                                setSelectedToDelete(data);
                                setIsDelete(true)
                                // window.scrollTo({ top: 0, behavior: 'smooth' });                              
                              }}
                            />
                          </td>
                        }
                      </tr>
                    ))}
                  </tbody>
                </table>
                {userTotalCount > itemsCountPerPage &&
                  <div className='pagination-wrapper mt-4'>
                    <Pagination
                      activePage={activePage}
                      itemsCountPerPage={itemsCountPerPage}
                      totalItemsCount={userTotalCount}
                      pageRangeDisplayed={5}
                      onChange={(e) => handlePageChange(e)}
                    />
                  </div>
                }
              </>
            ) : (
              <div className="noData d-flex flex-column">
                <div>
                  <img src={noData} alt="noData" className="img-fluid" width="150" height="150" />
                </div>
                <div>No Data Available</div>
              </div>
            )) : (
            <div className="noData d-flex flex-column">
              <div>
                <img src={Loader} alt="noData" className="img-fluid" width="150" height="150" />
              </div>
            </div>
          )}
        </div>
        {addUserFlag &&
          <AddUser cancelPopup={cancelPopup} userListFn={userListFn}
            selectedUser={selectedUser} mode={mode} setOffset={setOffset} setActivePage={setActivePage} />
        }
      </div>
    </div>
  )
}

export default UserList